module.exports = __webpack_public_path__ + "img/vip4.28509091.png";